import { render, staticRenderFns } from "./VirtualAccountBLPaymentTarget.vue?vue&type=template&id=fbcd34a6&scoped=true&class=bl_payment_pop"
import script from "./VirtualAccountBLPaymentTarget.vue?vue&type=script&lang=js"
export * from "./VirtualAccountBLPaymentTarget.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccountBLPaymentTarget.vue?vue&type=style&index=0&id=fbcd34a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcd34a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbcd34a6')) {
      api.createRecord('fbcd34a6', component.options)
    } else {
      api.reload('fbcd34a6', component.options)
    }
    module.hot.accept("./VirtualAccountBLPaymentTarget.vue?vue&type=template&id=fbcd34a6&scoped=true&class=bl_payment_pop", function () {
      api.rerender('fbcd34a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/VirtualAccountBLPaymentTarget.vue"
export default component.exports